

import * as React from 'react';
import { Box, Heading2, Modal, thc } from '@flightstats/airframe-react';

import { isWindowSmallerThan } from './CiriumFormUtils';

type SuccessModalProps = {
  showModal: boolean,
  closeModal?: () => void,
  title: string,
  children: React.ReactNode,
};

const mobileContentStyle = {
  boxSizing: 'border-box',
  height: '100%',
  width: '100%',
};

const ModalContentWrapper = thc(Box, {
  margin: 'auto',
  width: {
    xs: 'auto',
    sm: '425px',
  },
  p: {
    xs: '0px',
    sm: '10px 25px',
  },
});

export const CiriumModal = ({
  showModal,
  closeModal,
  title,
  children,
}: SuccessModalProps) => (
  <Modal
    isOpen={showModal}
    onRequestClose={closeModal}
    enableBodyScroll={showModal ? false : true}
    overflowOnClose="visible" //w/o this, scrolling doesn't consistently unlock when showModal goes back to false
  >
    <ModalContentWrapper>
      <Heading2 spacing={2}>{title}</Heading2>
      {children}
    </ModalContentWrapper>
  </Modal>
);
